import { render, staticRenderFns } from "./GetClueAnswers.vue?vue&type=template&id=7bfe45e6&scoped=true&"
import script from "./GetClueAnswers.vue?vue&type=script&lang=js&"
export * from "./GetClueAnswers.vue?vue&type=script&lang=js&"
import style0 from "./GetClueAnswers.vue?vue&type=style&index=0&id=7bfe45e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfe45e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
